/**
 * The theme's dataLayer events that happen in the browser.
 *
 * Its own bundle (build/js/analytics.js), apart from screen.js: lib/analytics.php
 * enqueues it only where analytics_active() says events are pushed, and marks
 * it for Cookiebot to leave alone, as Tag Manager is. The events go through
 * window.diakonPush(), defined in the head before anything else.
 */
import { initStoreAnalytics } from './store.js';
import { initDonationAnalytics } from './donations.js';

document.addEventListener('DOMContentLoaded', () => {
	const push = window.diakonPush;

	if (!push) {
		return;
	}

	initStoreAnalytics(push);
	initDonationAnalytics(push);
});
